import {Column, Entity, PrimaryGeneratedColumn} from "typeorm"

@Entity({name: "wireless_logic_usage_daily"})
export class WirelessLogicUsageDaily {

	@PrimaryGeneratedColumn()
	id!: number

	@Column()
	iccid!: string
	
	@Column()
	msisdn!: string
	
	@Column({ type: "bigint" })
	month_to_date_bytes_up!: number
	
	@Column({ type: "bigint" })
	month_to_date_bytes_down!: number
	
	@Column({ type: "bigint" })
	month_to_date_voice_up!: number
	
	@Column({ type: "bigint" })
	month_to_date_voice_down!: number
	
	@Column({ type: "bigint" })
	month_to_date_sms_up!: number
	
	@Column({ type: "bigint" })
	month_to_date_sms_down!: number
	
	@Column({ type: 'datetime', nullable: true })
	last_seen!: Date
	
	@Column()
	in_current_session!: boolean
	
	@Column('datetime')
	timestamp!: Date
}